import { Phone } from 'lucide-react'
import { PageHero } from '../components/PageHero'
import { ResponsiveImage } from '../components/ResponsiveImage'
import { images } from '../data/images'
import { contact } from '../data/site'

export function GivingBack() {
  return (
    <>
      <PageHero eyebrow="Community" title="Giving Back" image={images['giving-back']} objectPosition="center 44%" />
      <section className="giving-story">
        <header className="giving-lead section shell reveal reveal--heading">
          <span className="eyebrow">Our Commitment</span>
          <h2>Supporting our community.</h2>
          <p>At Diamond Salon, beauty extends beyond the surface. We believe in the power of community and take pride in supporting local children and families in need.</p>
        </header>
        <figure className="giving-feature reveal reveal--image">
          <ResponsiveImage image={images['giving-back']} alt="Students standing together at school" sizes="100vw" objectPosition="center 44%" />
          <figcaption>Community, care, and the value of showing up for one another.</figcaption>
        </figure>
        <div className="giving-body section shell">
          <aside className="giving-quote reveal"><p>“We believe in the beauty of generosity.”</p></aside>
          <article className="giving-copy reveal">
            <p>Veronica Lake, the dedicated owner of Diamond Salon, understands the value of extending a helping hand to those who require assistance in our community. With a heartfelt commitment to making a positive impact, Veronica and our team actively support our local community.</p>
            <p>We invite you to be part of that mission. Your support helps us continue extending a hand to those who need it most.</p>
            <p>Thank you for choosing Diamond Salon, where beauty goes beyond the surface and we make a difference together.</p>
            <a className="button" href={contact.phoneHref}><Phone /> Call {contact.phoneDisplay}</a>
          </article>
        </div>
      </section>
    </>
  )
}
